import React from "react";
import { Section, Container, Heading, Card, CardInner } from "toddlar-ui";
import PlayfulSelectToySVG from "./animations/ToySelectionAnimation";
import ClockAnimation from "./animations/ClockAnimation";
import ShipmentAnimation from "./animations/ShipmentAnimation";
import KeepForeverAnimation from "./animations/KeepForeverAnimation";

const HowItWorks: React.FC = () => {
  const steps = [
    {
      num: 1,
      title: "Choose toys to borrow",
      description:
        "Pick from our latest must‑haves and classics your kids will love.",
      icon: "🧸",
    },
    {
      num: 2,
      title: "Total flexibility",
      description:
        "Keep toys for as long as they’re loved at home. No late fees.",
      icon: "💛",
    },
    {
      num: 3,
      title: "Swap and repeat",
      description:
        "Return any unloved toy and swap it for something else when you’re ready.",
      icon: "📦",
    },
    {
      num: 4,
      title: "Or keep them forever",
      description:
        "If a favourite has stolen their heart, you can buy it from us.",
      icon: "🛒",
    },
  ];

  return (
    <Section background="orange-sand">
      <Container>
        <Heading size="h2" className="text-center mb-8">
          How it works
        </Heading>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s) => (
            <div key={s.num} className="flex flex-col">
              {/* Visual tile with large step number and either animation or icon */}
              <Card className="relative overflow-hidden">
                <CardInner
                  className={`${
                    s.num === 1
                      ? "aspect-[4/1] md:aspect-[16/6]"
                      : "aspect-[4/3]"
                  } flex items-center justify-center bg-sand-100`}
                >
                  {s.num !== 1 && (
                    <div className="absolute inset-0 grid place-items-center">
                      <span className="text-[120px] font-bold text-sand-300 select-none leading-none"></span>
                    </div>
                  )}
                  {s.num === 1 ? (
                    <PlayfulSelectToySVG />
                  ) : s.num === 2 ? (
                    <ClockAnimation />
                  ) : s.num === 3 ? (
                    <ShipmentAnimation />
                  ) : s.num === 4 ? (
                    <KeepForeverAnimation />
                  ) : (
                    <div className="relative text-6xl select-none"></div>
                  )}
                </CardInner>
              </Card>

              {/* Copy */}
              <div className="mt-4">
                <h3 className="text-sm font-semibold uppercase tracking-wide text-ink">
                  {s.title}
                </h3>
                <p className="mt-1 text-sm text-ink-muted">{s.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default HowItWorks;
